import { Elements } from '@stripe/react-stripe-js';
import PropTypes from 'prop-types';
import { stripePromise } from '../lib/stripeJs';

// Wraps the app inside Stripe Elements so Stripe.js + the secure iframes are available
// to any payment surface (card-on-file, future invoice charging, subscriptions).
// Mounted inside the auth provider (only authenticated users need Stripe.js) and outside
// the router (so Profile + Billing routes can mount Elements).
export function StripeProvider({ children }) {
  return <Elements stripe={stripePromise}>{children}</Elements>;
}

StripeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
